import { Typography, Button } from "../../components"
import "./styles.css";

export default function Offertebrochure(props) {
    return (
        <div className="container">
            <iframe
                title="Offertebrochure NOLIA BabyFeeding"
                src="https://app.enormail.eu/subscribe/4d0a79d1fd7ef066d078ef6a8c136371"
                style={{
                width: "100%",
                height: "100vh",
                border: "none"
                }}
                allow="fullscreen; payment"
            ></iframe>
        </div>
    )
}